import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../../../shared/auth.guard';
import { MunicipalPoliceGuard } from '../../../shared/municipal-police.guard';

import { RegisterComponent } from './register.component';

const routes: Routes = [
  {
    path: 'register',
    component: RegisterComponent,
    canActivate: [AuthGuard, MunicipalPoliceGuard],
    data: {
      breadcrumb: 'Register New User'
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RegisterRoutingModule { }
